/** The knowledge inbox, optionally showing only suggestions from chats in one space. */
export const inboxPath = (spaceUuid?: string) =>
  spaceUuid ? `/knowledge/inbox?space=${encodeURIComponent(spaceUuid)}` : "/knowledge/inbox";
